module.exports = __webpack_public_path__ + "static/media/quick_links.781796c9.png";